/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";

const shapes = {
  square: "tw-rounded-[0px]",
};

const variants = {
  fill: {
    purple_50: "tw-bg-purple-50 tw-text-gray-900",
    white_A700: "tw-bg-white-a700",
  },
};

const sizes = {
  md: "tw-h-[98px] tw-px-6 tw-text-[14px]",
  xs: "tw-h-[42px] tw-px-2.5 tw-text-[16px]",
  sm: "tw-h-[44px] tw-px-2.5",
};

const Input = React.forwardRef(
  (
    {
      className = "",
      name = "",
      placeholder = "",
      type = "text",
      label = "",
      prefix,
      suffix,
      onChange,
      shape,
      variant = "fill",
      size = "md",
      color = "white_A700",
      ...restProps
    },
    ref,
  ) => {
    return (
      <label
        className={`tw-${className} tw-flex tw-items-center tw-justify-center tw-cursor-text ${shape && shapes[shape]} ${variant && (variants[variant]?.[color] || variants[variant])} ${size && sizes[size]}`}
      >
        {!!label && label}
        {!!prefix && prefix}
        <input ref={ref} type={type} name={name} placeholder={placeholder} onChange={onChange} {...restProps} className="tw-flex-1 tw-outline-none" />
        {!!suffix && suffix}
      </label>
    );
  },
);

Input.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  shape: PropTypes.oneOf(["square"]),
  size: PropTypes.oneOf(["md", "xs", "sm"]),
  variant: PropTypes.oneOf(["fill"]),
  color: PropTypes.oneOf(["purple_50", "white_A700"]),
};

export { Input };
